import { UserSettings } from "../models/user-settings";
import { Action } from "@ngrx/store";

export const LOAD = '[UserSettings] Load';
export const LOAD_COMPLETE = '[UserSettings] Load Complete';
export const LOAD_ERROR = '[UserSettings] Load Error';
export const LOAD_FROM_SIGNIN = '[UserSettings] Load after sign in';


export class Load implements Action {
  readonly type = LOAD;
  constructor(public payload?: any) { }
}

export class LoadFromSignIn implements Action {
  readonly type = LOAD_FROM_SIGNIN;
  constructor(public payload?: any) { }
}


export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: UserSettings) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload : any ) { }
}

export type Actions =
  Load |
  LoadFromSignIn |
  LoadComplete |
  LoadError;
